/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSavingsCustomerConfigRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {GetSavingsCustomerConfigResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const getSavingsCustomerConfig = (request: GetSavingsCustomerConfigRequest, options?: CashRequestOptions) => post<GetSavingsCustomerConfigRequest, GetSavingsCustomerConfigResponse>("/2.0/cash/get-savings-customer-config", request, {...options, rejectOnError: true })